import { ImpactLensProfileLayer } from '@upright/ui/common/upright/core/impact-lenses/types';
import { compact } from 'lodash';
import { useCarouselContext } from '../context';

interface Props {
  layer: ImpactLensProfileLayer;
}

export function InfoBoxes(props: Props) {
  // Code that drew all lenses
  // const lenses = allImpactLenses;
  // const boxes = lenses.map(lensType => {
  //   const lens = getLens(lensType);
  //   function pickComponent() {
  //     if (props.layer === ImpactLensProfileLayer.DIV) {
  //       return lens.infoBoxes.DivComponent;
  //       // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  //     } else if (props.layer === ImpactLensProfileLayer.SVG) {
  //       return lens.infoBoxes.SvgComponent;
  //     }
  //     return undefined;
  //   }
  //   const Component = pickComponent();
  //   return Component ? <Component key={lensType} /> : undefined;
  // });

  // Draw only one lens
  const context = useCarouselContext();
  const lens = context.lens;
  const Component = (() => {
    if (props.layer === ImpactLensProfileLayer.DIV) {
      return lens.infoBoxes.DivComponent;
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    } else if (props.layer === ImpactLensProfileLayer.SVG) {
      return lens.infoBoxes.SvgComponent;
    } else {
      return undefined;
    }
  })();
  const boxes = [Component ? <Component key={context.lensType} /> : undefined];
  return <>{compact(boxes)}</>;
}
